import Swiper from 'swiper/bundle';

$(document).ready(() => {
    $('.portfolio').each(function () {
        const $section = $(this);
        const $sliderEl = $section.find('.portfolio__slider');

        if (!$sliderEl.length) return;

        const $pins = $section.find('.portfolio__map .js-portfolio-pin');

        const setActivePinByKey = (key) => {
            $pins.removeClass('is-active');
            if (!key) return;
            $pins.filter(`[data-pin-key="${key}"]`).addClass('is-active');
        };

        const swiper = new Swiper($sliderEl[0], {
            loop: true,
            slidesPerView: 3,
            centeredSlides: true,
            spaceBetween: 32,

            breakpoints: {
                0: {
                    slidesPerView: 1,
                    centeredSlides: false,
                    spaceBetween: 0,
                },
                768: {
                    slidesPerView: 3,
                    centeredSlides: true,
                    spaceBetween: 32,
                }
            },

            navigation: {
                nextEl: $section.find('.swiper-button-next')[0],
                prevEl: $section.find('.swiper-button-prev')[0],
            },
            pagination: {
                el: $section.find('.swiper-pagination')[0],
                clickable: true,
            },

            on: {
                init () {
                    const key = this.slides[this.activeIndex]?.dataset?.pinKey;
                    setActivePinByKey(key);
                },
                slideChange () {
                    const key = this.slides[this.activeIndex]?.dataset?.pinKey;
                    setActivePinByKey(key);
                },
            },
        });

        $section.on('click', '.portfolio__map .js-portfolio-pin', function () {
            const key = this.dataset.pinKey;
            if (!key) return;

            const slideEl = swiper.slides.find((el) => el.dataset?.pinKey === key);
            if (!slideEl) return;

            const originalIndex = parseInt(slideEl.getAttribute('data-swiper-slide-index'), 10);
            if (Number.isNaN(originalIndex)) return;

            swiper.slideToLoop(originalIndex);
        });
    });
});
